import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiLoadingModule } from 'omnium-ui/loading';

@Component({
  selector: 'dbw-state-card',
  imports: [OuiLoadingModule],
  styleUrl: './state-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <section
      class="dbw-card dbw-card--xl"
      [class.state-panel]="appearance() === 'loading'"
      [class.feedback]="appearance() !== 'loading'"
      [class.error]="appearance() === 'error'"
      [class.info]="appearance() === 'info'"
      [class.compact]="compact()"
    >
      @if (appearance() === 'loading') {
        <oui-loading size="small"></oui-loading>
      }

      @if (title()) {
        @switch (titleLevel()) {
          @case ('h5') {
            <h5>{{ title() }}</h5>
          }
          @default {
            <h4>{{ title() }}</h4>
          }
        }
      }

      <ng-content></ng-content>
    </section>
  `
})
export class StateCardComponent {
  readonly appearance = input<'loading' | 'error' | 'info'>('info');
  readonly title = input<string>();
  readonly titleLevel = input<'h4' | 'h5'>('h4');
  readonly compact = input(false);
}
